import { AsyncPipe } from "@angular/common";
import { Component, OnInit, inject } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { ConfigurationService } from "../../../services/configuration.service";

@Component({
  selector: "app-quickscan-filter",
  imports: [ReactiveFormsModule, MatLabel, MatDatepickerModule, MatFormFieldModule, MatOptionModule, AsyncPipe],
  templateUrl: "./quickscan-filter.component.html",
  styleUrls: ["./quickscan-filter.component.less"],
})
export class QuickscanFilterComponent implements OnInit {
  public formGroup: FormGroup;

  public loading: boolean;
  public readonly maxDate: Date;
  public readonly minDate: Date;

  public config: ConfigurationService;

  public constructor() {
    this.config = inject(ConfigurationService);

    this.formGroup = new FormGroup({
      startDate: new FormControl(""),
      endDate: new FormControl(""),
      companyName: new FormControl(""),
    });

    this.loading = false;
    this.maxDate = new Date();
    this.minDate = new Date(2020, 0, 1);
  }

  public async ngOnInit(): Promise<void> {
    await this.config.getCustomers();
  }

  public async getFilteredQuickScans(): Promise<void> {
    this.loading = true;

    const startDate = new Date(this.formGroup.controls["startDate"].value);
    const endDate = new Date(this.formGroup.controls["endDate"].value);

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(24, 0, 0, 0);
    const filterValues = {
      startDate: this.dateToUnix(startDate),
      endDate: this.dateToUnix(endDate),
      companyName: this.formGroup.controls["companyName"].value,
    };
    await this.config.getFilteredQuickScans(filterValues);
    this.loading = false;
  }

  public dateToUnix(date: Date): number {
    return Math.floor(date.getTime() / 1000);
  }
}
